var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1040",
    "data-name": "Grupo 1040",
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.745,
    height: 88.745,
    viewBox: "0 0 88.745 88.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusi\\xF3n_1",
    "data-name": "Exclusi\\xF3n 1",
    d: "M44.373,88.745A44.384,44.384,0,0,1,27.1,3.487,44.384,44.384,0,0,1,61.645,85.258,44.1,44.1,0,0,1,44.373,88.745ZM38.608,34.8a1.861,1.861,0,0,0,0,3.722h3.72V51.135a2.068,2.068,0,0,0,4.136,0V38.527h3.72a1.861,1.861,0,0,0,0-3.722Zm-15.087,0a2.116,2.116,0,0,0-2.067,2.067V51.339A1.907,1.907,0,0,0,23.52,53.2a2.118,2.118,0,0,0,2.066-2.065V47.619h2.894c4.59,0,7.441-2.534,7.441-6.614,0-3.767-2.759-6.2-7.03-6.2ZM58.244,48.654H66.1l1.24,2.894A2.058,2.058,0,0,0,69.4,52.994a1.863,1.863,0,0,0,1.862-1.86,1.085,1.085,0,0,1-.206-.309,1.082,1.082,0,0,0-.208-.311L64.444,36.044a2.411,2.411,0,0,0-2.274-1.653h-.208a2.544,2.544,0,0,0-2.272,1.448L53.283,50.307a1.561,1.561,0,0,0-.206,1.034,1.484,1.484,0,0,0,.62,1.241,1.526,1.526,0,0,0,1.24.412h.206A1.823,1.823,0,0,0,57,51.754l1.24-3.1Zm5.993-3.308H59.69l2.272-5.166,2.275,5.164ZM28.481,43.9H25.587V38.527h3.1c.518,0,3.1.129,3.1,2.686C31.788,42.869,30.521,43.9,28.481,43.9Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPta);
export default __webpack_public_path__ + "static/media/ic_pta.4c9afdf820ab4ed815db93c6ed649afe.svg";
export { ForwardRef as ReactComponent };